import React, { useState } from "react";
import _ from "lodash";
import WarningIcon from "../../../img/svg/WarningIcon.svg";
import SuccessIcon from "../../../img/svg/SuccessIcon.svg";
import { groupItemsByStation } from "../../../utils/Helpers";
import Modal from "../../generics/Modal";

const PriceCell = ({ item }) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <div className="d-flex">{item.price}</div>
      </div>
    </td>
  );
};

const TotalPriceCell = ({ item }) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <div className="d-flex">{item.price * item.quantity * item.number_items}</div>
      </div>
    </td>
  );
};

const BestPriceCell = ({ item, handleShowOptions }) => {
  return (
    <td>
      <div className="offer-warning" onClick={item.has_better_offer ? handleShowOptions : undefined}>
        {item.has_better_offer ? (
          <img style={{ height: "30px", cursor: 'pointer' }} src={WarningIcon} />
        ) : (
          <img style={{ height: "30px" }} src={SuccessIcon} />
        )}
        <div className="offer-warning-detail">
          {item.has_better_offer
            ? `This item has a cheaper price from ${item.has_better_offer.display_name}`
            : `This item has the best price of all lists`}
        </div>
      </div>
    </td>
  );
};

const Inventory = ({ inventoriesCount }) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <div className="d-flex">{inventoriesCount}</div>
      </div>
    </td>
  );
};

const ActionCell = ({ handleEditItem, handleDeleteItem }) => {
  return (
    <td>
      <span className="d-flex">
        <button className="mr-05 btn-sm btn-primary btn" onClick={handleEditItem}>
          <i className="fa fa-pencil"></i>
        </button>
        <button className="mr-05 btn-sm btn btn-danger" onClick={handleDeleteItem}>
          <i className="fa fa-trash"></i>
        </button>
      </span>
    </td>
  );
};

const Item = ({
  item,
  status,
  handleEditItem,
  handleShowOptions,
  handleDeleteItem,
  showActionColumn,
  showInventoriesColumn,
  inventories,
}) => {
  return (
    <tr>
      <td>{item ? item.name : ""}</td>
      <td>{item.brand ? item.brand.brand_name : "-"}</td>
      <td>
        <b>{item.quantity}</b>
        <span className="ml-05 badge badge-pill badge-info">{item.presentation ? item.presentation : "Case"}</span>
      </td>
      <td>{item.grade ? item.grade.grade : "N/A"}</td>
      <td>{item.number_items}</td>
      <PriceCell item={item} />
      <TotalPriceCell item={item} />
      <BestPriceCell item={item} handleShowOptions={handleShowOptions} />
      {showInventoriesColumn && <Inventory inventoriesCount={inventories} />}
      {showActionColumn && <ActionCell handleEditItem={handleEditItem} handleDeleteItem={handleDeleteItem} />}
    </tr>
  );
};

const PurchaseOrderByPriceDetail = ({
  purchaseOrder,
  handleEditItem,
  handleShowOptions,
  handleDeleteItem,
  handleDeliveryDate,
  deliveryDate,
  handleCheck,
  checked,
  deliveryDateError,
  listUncheckedError,
  handleDeleteTable,
  marketDetail,
}) => {
  const itemsByStation = groupItemsByStation(purchaseOrder.items);
  const status = purchaseOrder.status;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleDeleteModal = () => {
    setOpenDeleteModal(!openDeleteModal);
  };
  return (
    <div key={purchaseOrder.id} className="card">
      <div className="card-block p-0 overflow-auto">
        <div className="card-header d-flex flex-row">
          <div
            className={`d-flex ${marketDetail ? "flex-row align-items-end" : "flex-column justify-content-center"} `}
            style={{ marginRight: "15px" }}
          >
            <h4>Vendor</h4>
            <label className={marketDetail && " ml-05"}>{purchaseOrder.vendor && purchaseOrder.vendor.name}</label>
          </div>
          {!marketDetail && (
            <div className={`${deliveryDateError ? "has-danger col-12 col-sm-4" : "col-6 col-sm-2"}`}>
              <label className="col-form-label filter-label" style={{ color: "#36a9e1" }} htmlFor="select">
                <i className="fa fa-calendar-o mr-05 ml-05"></i>
                Delivery Date
              </label>
              <input
                type="date"
                id="date"
                className="form-control"
                value={deliveryDate}
                style={{ height: "30px" }}
                onChange={(date) => handleDeliveryDate(date, purchaseOrder.id)}
              />
              {deliveryDateError && <small className="error form-control-feedback">{deliveryDateError}</small>}
            </div>
          )}
          {!marketDetail && (
            <div className={"col-12 col-sm-4"}>
              <div className="d-flex flex-column justify-content-center mr-h">
                <label className="col-form-label filter-label" style={{ color: "#36a9e1" }} htmlFor="check">
                  Select list
                </label>
                <div
                  className="d-flex flex-row"
                  style={{
                    width: "fit-content",
                    padding: "3px 5px",
                    height: "30px",
                  }}
                >
                  <span>
                    Select the list to create the order
                  </span>
                  <input
                    className="form-check"
                    type="checkbox"
                    value={checked}
                    onChange={() => handleCheck(!checked, purchaseOrder.id)}
                    style={{ marginBottom: "-1px", marginLeft: "5px" }}
                  />
                  {listUncheckedError && <small className="error form-control-feedback">This list will be lost if unchecked</small>}
                </div>
              </div>
            </div>
          )}
        </div>
        <table className="table table-striped table-order-station datatable mb-0">
          <thead className="thead-inverse">
            <tr>
              <th>Item</th>
              <th>
                <span>Manufacturer</span>
                <span className="hidden-sm-up">Mfr.</span>
              </th>
              <th>Qty</th>
              <th>Grade</th>
              <th>Pieces</th>
              <th>Unit Price</th>
              <th>Total Price</th>
              <th>Best Price</th>
              {!marketDetail && <th>Actions</th>}
            </tr>
          </thead>
          {Object.keys(itemsByStation).length == 0 && (
            <tbody>
              <tr>
                <td className="grey pl-3" colspan="9" style={{ padding: "5px," }}>
                  No items were added yet
                </td>
              </tr>
            </tbody>
          )}
          {Object.keys(itemsByStation).map((station) => (
            <tbody>
              <tr>
                <td className="grey pl-3" colspan="9" style={{ padding: "5px,", textTransform: "uppercase" }}>
                  {station}
                </td>
              </tr>
              {itemsByStation[station].map((item, index) => {
                return (
                  <Item
                    item={item}
                    key={`item-${index}`}
                    status={status}
                    handleEditItem={() => handleEditItem(item)}
                    handleShowOptions={() => handleShowOptions({ item, purchaseOrder })}
                    handleDeleteItem={() => handleDeleteItem(item.id, purchaseOrder.id)}
                    inventories={item.labels.reduce((acc_label, label) => acc_label + label.number_inventories, 0)}
                    showActionColumn={!marketDetail}
                  />
                );
              })}
            </tbody>
          ))}
        </table>
        {!marketDetail && (
          <div className="card-header d-flex flex-row justify-content-end">
            <label className="col-form-label color-danger" style={{ marginRight: "8px", padding: "0px" }} htmlFor="check">
              Delete the entire list
            </label>
            <button className="mr-05 btn-sm btn btn-danger" onClick={handleDeleteModal}>
              <i className="fa fa-trash"></i>
            </button>
          </div>
        )}
      </div>
      <Modal
        closeModal={() => setOpenDeleteModal(false)}
        isModalOpen={openDeleteModal}
        onConfirm={() => {
          handleDeleteTable(purchaseOrder.id);
          setOpenDeleteModal(false);
        }}
        onCancel={() => setOpenDeleteModal(false)}
        header="Delete Purchase Order"
        content={`Are you sure you want to delete the purchase order from ${purchaseOrder.vendor.name}?`}
        onConfirmButtonText="Yes"
        onCancelButtonText="No"
      />
    </div>
  );
};

export default PurchaseOrderByPriceDetail;
